<div class="header_search">
  <div class="title-page">
    <h3>Indicadores</h3>
  </div>
  <div class="content_search">
    <div class="new-project btn-wx" *ngIf="permission?.canCreat && permission?.pfIndCount">
      <button class="btn btn-default" type="btn" *ngIf="!ordenacao" (click)="ordenacao = true">Ordenação</button>
      <button class="btn btn-default" type="btn" *ngIf="ordenacao" (click)="salvarOrdem()">Salvar Ordem</button>
    </div>
    <div class="new-project" *ngIf="permission?.canCreat">
      <a class="btn btn-primary" type="btn" [routerLink]="novo()">Novo</a>
    </div>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!ordenacao" [ngClass]="{'ordenacao': ordenacao}">
      <thead>
        <tr>
          <th *ngIf="ordenacao" class="text-center">Ordenação</th>
          <th class="text-center">Código</th>
          <th>Indicador</th>
          <th class="text-center">Polar.</th>
          <th class="text-center">Medida</th>
          <th class="text-center">Meta</th>
          <th class="text-center">Realizado</th>
          <th class="text-center">Apuração</th>
          <th class="text-center">Status</th>
          <th class="text-center">Projeção</th>
          <th class="text-center">PC</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of indicadoresList; let i = index">
          <tr cdkDrag>
            <td class="title text-center" *ngIf="ordenacao">{{ i + 1 }}</td>
            <td class="text-center" [ngClass]="{'title': !ordenacao}">{{ item?.code }}</td>
            <td>
              <span class="title-span">{{item?.title}}</span>
              <div class="responsavel">
                <img *ngIf="item?.resp_nome" src="assets/images/svgs/responsavel.svg" alt="Responsavel" [tooltip]="item?.resp_nome" placement="bottom" (click)="viewResonsavel(item)">
                <div *ngIf="item?.level_mon_id" class="tag">Estratégico</div>
              </div>
            </td>
            <td>
              <div class="text-center icon-system-Seta_cima2" [ngClass]="{'rotate': !item?.polarity}"></div>
            </td>
            <td>
              {{ item?.unit_id }}
              <div *ngIf="item?.accum || item?.accum_table; else accum">
                <small>Acumulado</small>
                <div *ngIf="item?.accum_table">
                  <small>(visão composta)</small>
                </div>
              </div>
              <ng-template #accum>
                <div>
                  <small>Não Acumulado</small>
                </div>
              </ng-template>
            </td>
            <td class="text-center">{{ item?.meta }}</td>
            <td class="text-center">{{ item?.current_done }}</td>
            <td class="text-center">{{ item?.current_month }}</td>
            <td class="status">
              <div [innerHTML]="item?.status"></div>
            </td>
            <td class="text-center status">
              <div class="stat_id" *ngIf="item?.stat_id; else stat">
                <span *ngIf="item?.stat_id == 1" class="icon-system-Seta_cima"></span>
                <span *ngIf="item?.stat_id == 2" class="icon-system-Dificuldades"></span>
                <span *ngIf="item?.stat_id == 3" class="icon-system-Seta_baixo"></span>
              </div>
              <ng-template #stat>
                <div>
                  <span class="ind-status ind-status-0"></span>
                </div>
              </ng-template>
            </td>
            <td class="destaque-red">{{ item?.total_pc }}</td>
            <td>
              <div class="btn-icon">
                <a class="icon-table" [routerLink]="viewIndicador(item?.id)">
                  <img src="assets/images/svgs/lupa.svg" alt="Visualizar" tooltip="Visualizar" placement="bottom">
                </a>
                <span class="icon-table" (click)="viewInfo(item)" *ngIf="item?.viewInfo">
                  <img src="assets/images/svgs/arrows-{{item?.viewInfoActive ? 'close' : 'open'}}.svg" alt="Situação" [tooltip]="item?.viewInfoActive ? 'Ocultar situação' : 'Mostrar situação'" placement="bottom">
                </span>
              </div>
            </td>
          </tr>
          <tr *ngIf="item?.viewInfoActive && item?.analysis_description">
            <td class="title" colspan="11"><strong>Análise em {{ item?.ctr_dth_atu }}:</strong>{{ item?.analysis_description }}</td>
          </tr>

          <ng-container *ngIf="item?.viewInfoActive && item?.analysis">
            <tr *ngFor="let analysis of item?.analysis">
              <!-- <td class="title" colspan="11"><strong>Análise em {{ analysis?.ctr_dth_atu }}:</strong> {{ analysis?.description }}</td> -->
              <td class="title" colspan="11"><strong>Ponto Crítico de {{ analysis?.ctr_dth_atu }}:</strong> {{ analysis?.description }}</td>
            </tr>
          </ng-container>

          <tr *ngIf="item?.viewInfoActive && item?.goal">
            <td class="title" colspan="11">
              <strong>Início:</strong> {{ item?.year_start }}
              <strong style="padding-left: 5px;">Término:</strong> {{ item?.year_end }}
              <strong style="padding-left: 5px;">Valor Total:</strong> {{ item?.decimal_goal }}
            </td>
          </tr>

          <tr *ngIf="item?.viewInfoActive && item?.chartData">
            <td colspan="11">
              <canvas baseChart class="chart" [data]="item?.chartData" [options]="item?.chartOptions" [type]="item?.chartType"></canvas>
            </td>
          </tr>

          <ng-container *ngIf="item?.viewInfoActive && item?.action?.length && !(item?.action?.length === 1 && item?.action[0]?.deleted)">
            <tr>
              <th class="title" colspan="3">Atividades</th>
              <th class="text-center" colspan="2">Status</th>
              <th class="text-center" colspan="2">Linha de Base</th>
              <th class="text-center" colspan="2">Término previsto</th>
              <th class="text-center" colspan="2">Atualização</th>
            </tr>
            <ng-container *ngFor="let action of item?.action">
              <tr *ngIf="!action?.deleted">
                <td class="title" colspan="3">
                  {{action?.title}}
                  <div class="responsavel">
                    <img *ngIf="action?.resp_nome" src="assets/images/svgs/responsavel.svg" alt="Responsavel" [tooltip]="action?.resp_nome" placement="bottom" (click)="viewResonsavel(action)">
                  </div>
                </td>
                <td class="status" colspan="2">
                  <div>{{action?.status}}</div>
                  <div [innerHTML]="action?.status1"></div>
                </td>
                <td class="text-center" colspan="2">{{ action?.deadline_original }}</td>
                <td class="text-center" colspan="2">{{ action?.deadline }}</td>
                <td class="text-center" colspan="2">
                  <div>{{ action?.user }}</div>
                  <div>{{ action?.ctr_dth_atu }}</div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
        <tr *ngIf="!indicadoresList?.length" class="border-b-radius">
          <td colspan="11" class="text-center">Nenhum Indicador Cadastrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>
<app-modal-responsavel #modalResonsavel></app-modal-responsavel>